import { ResponseTranslation } from '../Translations';

/** Mirrors Finance.Models TripStatus. */
export enum TripStatus {
  Draft = 1,
  Submitted = 2,
  Open = 3,
  Rejected = 4,
  InSettlement = 5,
  Closed = 6,
}

/** The trips list tabs — mirrors Finance.Models TripListScope. */
export enum TripListScope {
  All = 0,
  Mine = 1,
  ToApprove = 2,
}

/** Global.Models CodedDocumentKey: an employee (EMP-######) or a cost center. */
export interface CodedDocumentKey {
  reference: string;
  code: string;
  name: string;
}

export interface NamedTranslationKey {
  reference: string;
  name: ResponseTranslation;
}

/** Global.Models ApproverType. */
export enum ApproverType {
  User = 0,
  Role = 1,
}

/** Global.Models ApprovalDecisionType. */
export enum ApprovalDecisionType {
  Approved = 0,
  Rejected = 1,
}

export interface ApprovalSlot {
  id: string;
  type: ApproverType;
  value: string;
  order: number | null;
  isRequired: boolean;
  fromAmountUsd: number | null;
}

export interface ApprovalDecision {
  slotId: string;
  username: string;
  at: string;
  decision: ApprovalDecisionType;
  comment: string | null;
}

/** Global.Models FrozenApproval — the approvers frozen on the trip at submit. */
export interface FrozenApproval {
  policyReference: string;
  policyName: ResponseTranslation;
  evaluatedUsdAmount: number;
  minimumApprovals: number;
  slots: ApprovalSlot[];
  decisions: ApprovalDecision[];
  isAutoApproved: boolean;
}

export interface TripStatusHistoryEntry {
  date: string;
  status: TripStatus;
  user: { username: string | null; firstName: string | null; lastName: string | null } | null;
}

/** An employee trip (#5788) — mirrors Finance.Models TripDto. */
export interface Trip {
  id: string;
  /** e.g. NT-TRIP-2026-000001 */
  number: string;
  financialCompanyReference: string;
  employee: CodedDocumentKey;
  employeeUsername: string | null;
  destination: string;
  departureDate: string;
  returnDate: string;
  purpose: string;
  costCenter: CodedDocumentKey;
  claimPolicy: NamedTranslationKey | null;
  approval: FrozenApproval | null;
  status: TripStatus;
  statusHistory: TripStatusHistoryEntry[] | null;
  /** Whether the caller can approve or reject it now (single reads only). */
  canDecide: boolean;
  createdBy: string | null;
  createdDate: string | null;
}

/** What the trip page sends on create and update. Dates are local calendar days (yyyy-MM-dd). */
export interface TripUpdate {
  employeeReference: string;
  destination: string;
  departureDate: string;
  returnDate: string;
  purpose: string;
  costCenterReference: string;
  claimPolicyReference: string | null;
}

export interface TripSearchCommand {
  search?: string | null;
  statuses?: TripStatus[] | null;
  scope?: TripListScope;
}

export interface TripSummary {
  open: number;
  submitted: number;
  inSettlement: number;
  toApprove: number;
}
